import cx from "clsx";
import React from "react";
import { FundraisingRegulator } from "../../../components/common/Icons";
import * as styles from "./Footer.module.scss";
export const MinimalFooter: React.FC = () => {
	return (
		<div className={styles.footerwrapper}>
			<div className={styles.footercomponent}>
				<div className={styles.footerbottom}>
					<div className={styles.bottomwrapper}>
						<div className={styles.legalwrapper}>
							<h6>© {new Date().getFullYear()} Dogs Trust</h6>
							<p className={styles.legalwrapperp}>
								Registered Charity Numbers: 1167663 and SC053144 &#38; Company
								No. 09365971. Donations are tax exempt and Gift Aid can be
								claimed.
							</p>
						</div>
						<div className={styles.fundraiseregswrapper}>
							<FundraisingRegulator width={"190px"} height={"60px"} />
						</div>
						<button
							type="button"
							id="ot-sdk-btn"
							className={cx(styles.cookiebutton, "ot-sdk-show-settings")}
						>
							Cookie Settings
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MinimalFooter;
